export enum ADMIN_STATUS_ENUM {
  ACTIVE = 'Activo',
  LOCKED = 'Bloquedo'
}

export enum ADMIN_STATUS_COLOR_ENUM {
  ACTIVE = 'primary',
  LOCKED = 'danger'
}
